import { PlusCircleTwoTone, MinusCircleFilled } from '@ant-design/icons'
import { Card, Input, Button, Radio, Upload, message, Popover, Form } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { setTabInfo, setTabActiveIndex, updateTabBase, deleteTabChildNode } from '@store/actions'
import api from '@services/api'
import ColorPicker from '@components/ColorPicker/index'
import { PARAM_SESSION_USER, PARAM_SESSION_KEY, getUserInfo } from '@utils/session'
import { withTranslation } from 'react-i18next'
import utils from '@/utils/utils'
interface ITabsProps {
  tabs: Array<any>
  activeIndex: number
  tabType?: string
  tabImage: Array<any>
  scrollTab?: boolean
  bgColor?: string
  activeColor?: string
  textColor?: string
}

export interface ITabsConfigProps {
  config: ITabsProps
  id: string
  editConfig: Function
  deleteTabs: Function
  switchTab: Function
  addTabs: Function
  setTabBase: Function
  t: (str: string) => string
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  editConfig: (key: string, value: string, index: number) => {
    dispatch(setTabInfo(ownProps.id, key || 'tabName', value, index))
  },

  deleteTabs: (index: number) => {
    dispatch(setTabInfo(ownProps.id, '', '', index))
    dispatch(deleteTabChildNode(ownProps.id, index))
  },

  switchTab: (index: number) => {
    dispatch(setTabActiveIndex(ownProps.id, index))
  },

  addTabs: (index: number) => {
    dispatch(setTabInfo(ownProps.id, 'tabName', `tab${index + 1}`, index))
  },
  setTabBase: (key: string, value: string) => {
    dispatch(updateTabBase(ownProps.id, key, value))
  },
  // setTabImageRes:()=>{
  //   dispatch(setTabItemImage(())
  // }
})

class TabsConfig extends Component<ITabsConfigProps> {
  state = {
    selectColor: '',
    selectName: '',
  }
  static defaultProps: ITabsConfigProps = {
    config: {
      tabs: [],
      activeIndex: 0,
      tabImage: [],
    },
    id: '',
    editConfig: function () {},
    deleteTabs: function () {},
    switchTab: function () {},
    addTabs: function () {},
    setTabBase: function () {},
    t: () => '',
  }

  componentDidMount() {
    const { config, addTabs } = this.props
    const { tabs } = config

    if (!tabs || tabs.length === 0) {
      addTabs(0)
    }
  }
  setcolor = e => {
    const { config } = this.props
    const name = e.target.dataset.name
    this.setState({
      selectName: name,
      selectColor: config[name],
    })
  }
  changeColor = color => {
    const { selectName } = this.state
    this.setState({
      selectColor: color,
    })
    this.props.setTabBase(selectName, color)
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 5,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 15,
        },
        sm: {
          span: 15,
        },
      },
    }
    const { config, editConfig, deleteTabs, switchTab, addTabs, setTabBase } = this.props
    const { tabs, activeIndex, tabType } = config
    const { selectColor } = this.state
    const beforeUpload = file => {
      const isValid =
        file.type === 'image/jpg' || file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isValid) {
        message.error('You can only upload JPEG/JPG/PNG file!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        message.error('Image must smaller than 2MB!')
      }
      return isValid && isLt2M
    }
    const deleteImage = e => {
      if (tabs && tabs.length > 0) {
        let index = -1
        for (let i = 0; i < tabs.length; i++) {
          if (tabs[i].tabImage[0].url === e.url) {
            index = i
            break
          }
        }
        if (index !== -1) {
          // index
          editConfig('tabImage', '', index)
        }
      }
    }

    const setImage = (event, index) => {
      const status = event.file.status
      if (status === 'error') {
        message.error(`${event.file.name} file upload failed.`)
      }
      let fileList = [...event.fileList]
      fileList = fileList.slice(-2)
      const imageList = fileList
        .map((file: any) => {
          if (file.status === 'done') {
            if (file.url) {
              return file
            }
            return {
              url: file.response.url,
              uid: file.uid,
              status: 'done',
            }
          }
          return file
        })
        .filter((f: { status: string } | any) => f && f.status !== 'error')
      editConfig('tabImage', imageList, index)
    }
    const t = this.props.t
    const content = <ColorPicker color={selectColor} handleOk={this.changeColor}></ColorPicker>
    return (
      <div className="tab_config_container">
        <Form>
          <Form.Item {...formItemLayout} label={t('tabType')}>
            <Radio.Group
              style={{
                marginLeft: 30,
              }}
              onChange={e => setTabBase('tabType', e.target.value)}
              value={config.tabType || 'text'}
            >
              <Radio value={'text'}>{t('tabText')}</Radio>
              <Radio value={'img'}>{t('tabImage')}</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item {...formItemLayout} label={t('tabTypeScrollable')}>
            <Radio.Group
              style={{
                marginLeft: 30,
              }}
              onChange={e => setTabBase('scrollTab', e.target.value)}
              value={config.scrollTab || false}
            >
              <Radio value={false}>{t('tabFixed')}</Radio>
              <Radio value={true}>{t('tabScrollable')}</Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
        {config.tabType !== 'img' && (
          <>
            <Form.Item {...formItemLayout} label={t('tabBackgroundColor')}>
              <Popover
                placement="right"
                title={t('tabBackgroundColor')}
                content={content}
                trigger="click"
              >
                <div
                  className="colorBtn"
                  style={{ backgroundColor: config.bgColor }}
                  data-name="bgColor"
                  onClick={this.setcolor}
                ></div>
              </Popover>
            </Form.Item>
            <Form.Item {...formItemLayout} label={t('tabActiveColor')}>
              <Popover
                placement="right"
                title={t('tabActiveColor')}
                content={content}
                trigger="click"
              >
                <div
                  className="colorBtn"
                  style={{ backgroundColor: config.activeColor }}
                  data-name="activeColor"
                  onClick={this.setcolor}
                ></div>
              </Popover>
            </Form.Item>
            <Form.Item {...formItemLayout} label={t('tabFontColor')}>
              <Popover
                placement="right"
                title={t('tabFontColor')}
                content={content}
                trigger="click"
              >
                <div
                  className="colorBtn"
                  style={{ backgroundColor: config.textColor }}
                  data-name="textColor"
                  onClick={this.setcolor}
                ></div>
              </Popover>
            </Form.Item>
          </>
        )}
        <Button
          type="primary"
          icon={<MinusCircleFilled />}
          style={{
            marginLeft: 30,
            marginTop: 20,
            marginBottom: 20,
          }}
          onClick={() => addTabs(tabs ? tabs.length : 0)}
        >
          {t('addTab')}
        </Button>
        {tabType !== 'img' ? (
          <Card
            bodyStyle={{
              padding: 10,
            }}
            style={{
              width: 600,
              marginTop: 10,
              marginLeft: 30,
            }}
          >
            <Form className="tab_config_form">
              {tabs &&
                tabs.map((item, index) => {
                  return (
                    <Form.Item {...formItemLayout} label={`#${index + 1} name`} key={`tab${index}`}>
                      <Input
                        value={item['tabName']}
                        className="input-lar-input"
                        allowClear={true}
                        type="text"
                        onChange={e => editConfig('tabName', e.target.value, index)}
                      />
                      <MinusCircleFilled
                        onClick={() => deleteTabs(index)}
                        style={{
                          color: '#f81d22',
                          fontSize: '22px',
                          marginLeft: '10px',
                        }}
                      />
                    </Form.Item>
                  )
                })}
            </Form>
          </Card>
        ) : (
          <Card
            bodyStyle={{
              padding: 10,
            }}
            style={{
              width: 600,
              marginTop: 10,
              marginLeft: 30,
            }}
          >
            <div className="lineTitle" style={{ fontSize: 22, marginBottom: 10 }}>
              <span style={{ marginLeft: 130 }}>默认Tab</span>
              <span style={{ marginLeft: 30 }}>选中Tab</span>
            </div>
            <Form className="tab_config_form">
              {tabs &&
                tabs.map((item, index) => {
                  return (
                    <Form.Item {...formItemLayout} label={`#${index + 1}`} key={`tab${index}`}>
                      <Upload
                        name="content"
                        className="upload_item"
                        listType="picture-card"
                        action={api['uploadImg']}
                        fileList={item.tabImage ? item.tabImage : []}
                        data={{
                          format: 'jpg',
                          fulldim: '320x180',
                          path: utils.generateImgName(),
                        }}
                        showUploadList={true}
                        beforeUpload={beforeUpload}
                        onRemove={e => deleteImage(e)}
                        onChange={e => setImage(e, index)}
                        headers={{
                          [PARAM_SESSION_USER]: getUserInfo()?.userId || '',
                          [PARAM_SESSION_KEY]: getUserInfo()?.sessionKey || '',
                        }}
                      >
                        {item.tabImage && item.tabImage.length >= 2 ? null : (
                          <PlusCircleTwoTone className="add_icon" twoToneColor="#1377cc" />
                        )}
                      </Upload>
                    </Form.Item>
                  )
                })}
            </Form>
          </Card>
        )}

        <div
          style={{
            paddingTop: 15,
            paddingLeft: 30,
            fontWeight: 700,
          }}
        >
          {t('switchCurrentTab')}
        </div>
        <Radio.Group
          style={{
            paddingTop: 15,
            paddingLeft: 30,
            paddingBottom: 15,
          }}
          name="activeIndex"
          defaultValue={activeIndex || 0}
          onChange={e => switchTab(e.target.value)}
        >
          {tabs &&
            tabs.map((_, index) => {
              return (
                <Radio value={index} key={`radio${index}`}>
                  tab #{index + 1}
                </Radio>
              )
            })}
        </Radio.Group>
      </div>
    )
  }
}

export default connect(null, mapDispatchToProps)(withTranslation()(TabsConfig))
